module.exports = __webpack_public_path__ + "static/jumbo-mask-4bbee8cfb3d2d073bd92b28f88f8e8eb.png";